module.exports = __webpack_public_path__ + "static/media/contract-footer.550a0b16.PNG";